<template>
    <div class="min-h-screen bg-gradient-to-br from-red-50 to-orange-100 flex items-center justify-center p-4">
        <div class="bg-white rounded-2xl shadow-xl w-full max-w-md p-8">
            <div class="text-center mb-8">
                <h1 class="text-3xl font-bold text-gray-800 mb-2">Inscription</h1>
                <p class="text-gray-600">Créez votre compte</p>
            </div>

            <template v-if="!beta">
                <div v-if="displayValidMessage" class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-3" role="alert">
                    <strong class="font-bold">Un email a été envoyé à {{ saveEmail }}</strong><br />
                    <span class="block sm:inline">Inscription réussie</span>
                </div>

                <div v-if="displayValidMessage" class="bg-orange-100 border border-orange-400 text-orange-700 px-4 py-3 rounded mb-6" role="alert">
                    <strong class="font-bold"><i class="fas fa-exclamation-triangle mr-1"></i> Pensez à vérifier vos spams.</strong><br />
                </div>

                <form @submit.prevent="handleSubmit" class="space-y-4">
                    <div class="grid grid-cols-2 gap-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">
                                <i class="fas fa-user mr-1 text-red-600"></i> Prénom
                            </label>
                            <input type="text" v-model="form.firstName"
                                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition"
                                placeholder="Jean" id="inp-prenom">
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">
                                <i class="fas fa-user mr-1 text-red-600"></i> Nom
                            </label>
                            <input type="text" v-model="form.lastName" 
                                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition"
                                placeholder="Dupont" id="inp-nom">
                        </div>
                    </div>

                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                            <i class="fas fa-envelope mr-1 text-red-600"></i> Email
                        </label>
                        <input type="email" v-model="form.email"
                            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition"
                            placeholder="jean.dupont@example.com" id="inp-email">
                    </div>

                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                            <i class="fas fa-building mr-1 text-red-600"></i> Nom de la société
                        </label>
                        <input type="text" v-model="form.companyName"
                            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition"
                            placeholder="Entreprise SA" id="inp-societe">
                    </div>

                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                            <i class="fas fa-phone mr-1 text-red-600"></i> Téléphone de la société
                        </label>
                        <input type="tel" v-model="form.companyPhone"
                            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition"
                            placeholder="+33 1 23 45 67 89" id="inp-telephone">
                    </div>

                    <button :disabled="loadingSend" type="submit" class="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-lg transition duration-200 mt-6">
                        <template v-if="loadingSend">
                            <i class="fas fa-spinner fa-spin mr-2"></i> Envoi en cours...
                        </template>
                        <template v-if="!loadingSend">
                            <i class="fas fa-user-plus mr-1"></i> S'inscrire
                        </template>
                    </button>
                </form>

                <p class="text-center text-gray-600 text-sm mt-6">
                    Déjà un compte ? 
                    <router-link to="/login" class="text-red-600 hover:text-red-700 font-medium">
                        Se connecter
                    </router-link>
                </p>
            </template>

            <template v-if="beta">
                <div class="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded mb-6" role="alert">
                    <strong class="font-bold"><i class="fas fa-info-circle mr-1"></i> A savoir</strong><br />
                    <span class="block sm:inline">Pour le bon développement de la plateforme, les inscriptions sont actuellement fermées. Pour toute demande d'accès, veuillez nous contacter via notre <router-link to="/contact" class="text-orange-800 hover:text-orange-900 underline font-medium"><i class="fas fa-link text-xs mr-0.5"></i> formulaire de contact</router-link>.<br />Un accès vous serez envoyé sous 48h maximum.<br />Merci de votre compréhension.</span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            beta: true,
            displayValidMessage: false,
            form: {
                firstName: '',
                lastName: '',
                email: '',
                companyName: '',
                companyPhone: '',
            },

            saveEmail: '',

            loadingSend: false,
        }
    },
    methods: {
        async handleSubmit() {
            const validation = this.$inpError([
                'inp-prenom:required|min=2',
                'inp-nom:required|min=2',
                'inp-email:required|email',
                'inp-societe:required|min=2',
                'inp-telephone:required|tel',
            ]);

            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }

            this.loadingSend = true
            let response = await this.$request.post('/auth/register', this.form)
            this.loadingSend = false

            this.saveEmail = this.form.email
            if (response.error) {
                this.$toast.error(response.error)
            } else {
                this.displayValidMessage = true
                this.form.firstName = ''
                this.form.lastName = ''
                this.form.email = ''
                this.form.companyName = ''
                this.form.companyPhone = ''
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>